module.exports = __webpack_public_path__ + "media/images/map-bg-03b7d46eddef609efc5defc56d440974.svg";